import * as yup from 'yup';

export const validationSchemaRectificativaParcial = yup.object().shape({
  ConceptoRectificativa: yup.string().required('El concepto de la rectificativa es obligatorio'),

  LineasRectificativa: yup
    .array()
    .of(
      yup.object().shape({
        PkLineasVenta: yup.number().required(),

        selected: yup.boolean().required(),

        ConceptoLinea: yup.string().when('selected', {
          is: true,
          then: schema => schema.required('El concepto de la línea es obligatorio'),
          otherwise: schema => schema.notRequired(),
        }),

        Unidades: yup.number().when('selected', {
          is: true,
          then: schema =>
            schema.typeError('Debe ser un número').min(1, 'Debe ser mayor que 0').required('Unidades es requerido'),
          otherwise: schema => schema.notRequired(),
        }),

        ReservaEuros: yup.number().when('selected', {
          is: true,
          then: schema =>
            schema
              .typeError('Debe ser un número')
              .min(0, 'Debe ser mayor o igual que 0')
              .required('Reserva en euros es requerida'),
          otherwise: schema => schema.notRequired(),
        }),

        InSituLineaDolares: yup.number().when('selected', {
          is: true,
          then: schema =>
            schema
              .typeError('Debe ser un número')
              .min(0, 'Debe ser mayor o igual que 0')
              .required('Coste in situ es requerido'),
          otherwise: schema => schema.notRequired(),
        }),
      }),
    )
    .test(
      'at-least-one-selected',
      'Debes seleccionar al menos una línea',
      value => Array.isArray(value) && value.some(linea => linea.selected),
    )
    .test('total-gt-zero', 'Para rectificar todas las líneas a cero se debe usar la opción rectificar a 0', value => {
      if (!Array.isArray(value)) return true;

      const total = value.reduce((sum, linea) => {
        return sum + (linea.ReservaEuros || 0) + (linea.InSituLineaDolares || 0);
      }, 0);

      return total > 0;
    })
    .required(),
});
